import React, {Component} from 'react';
import axios from "axios";
import {MuiPickersUtilsProvider, DateTimePicker} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import frLocale from "date-fns/locale/fr";
import { parse } from 'date-fns'

import AuthService from "../../AuthService";
import loader from "../../img/loader.gif";


class CroisiereDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            croisiereId: this.props.croisiereId,
            croisiereDate: parse(this.props.croisiereDate, 'dd/MM/yyyy HH:mm', new Date(), {locale: frLocale}),
            croisiereBateauId: this.props.croisiereBateauId,
            croisiereCapitaineId: this.props.croisiereCapitaineId,
            result: null,
            data: ''
        }

        this.change = this.change.bind(this);
        this.dateChange = this.dateChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    change(e) {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    dateChange(date) {
        this.setState({croisiereDate: date});
    }

    async submit(e) {
        e.preventDefault();
        await axios.post(AuthService.getUrl('/saveCroisire'), {
            croisiere: {
                id: this.state.croisiereId,
                date: this.state.croisiereDate,
                bateau: {
                    id : this.state.croisiereBateauId
                },
                utilisateur: {
                    id: this.state.croisiereCapitaineId
                }
            }
        }, AuthService.getAuthHeader()).then(
            this.loadData()
        );
    }

    async loadData() {
        await axios.post(AuthService.getUrl('/getCalendarByDate'), {
            croisiere: {
                id: this.state.croisiereId,
                date: this.state.croisiereDate
            }
        }, AuthService.getAuthHeader()).then(res => this.setState({
            result: res.return,
            data: res.data.data
        }));
    }

    getColumnStyle(bateau, index) {
        return {
            left: index * 108 + "px",
            color: bateau.planningColor
        };
    }

    getItemStyle(croisere) {
        var date = new Date(croisere.date);
        var hour = date.getHours();
        var min = date.getMinutes();

        return {
            top: (hour + (min === 30 ? 0.5 : 0) - 10) * 50 + "px",
            height: 50 * croisere.croisiereType.duree + "px",
            lineHeight: 50 * croisere.croisiereType.duree + "px",
            background: croisere.id === this.state.croisiereId ? "rgba(255,0,0,0.5)" : croisere.bateau != null ? croisere.bateau.planningColor : "autp"
        };
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div id="croisiereDialog">
                    <div className="dialogTitle">Detail de la croisière</div>
                    <div id="croisiereDialog-sidebar">
                        <form id="loginFormBox" onSubmit={e => this.submit(e)}>
                            <div className="label">Date croisière</div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                <DateTimePicker name="croisiereDate" value={this.state.croisiereDate} onChange={date => this.dateChange(date)}
                                                ampm={false}
                                                format="dd/MM/yyyy HH:mm"
                                                inputVariant="outlined"
                                                minutesStep={30}/>
                            </MuiPickersUtilsProvider>

                            <div className="label">Bateau</div>
                            <select className="value" type="text" name="croisiereBateauId" value={this.state.croisiereBateauId} onChange={e => this.change(e)} style={{width: "300px"}}>
                                 <option value=""></option>
                                {this.state.data.bateaux.map(bateau => (
                                    <option key={bateau.id} value={bateau.id}>{bateau.nom}</option>
                                ))}
                            </select>
                            <div className="label">Capitaine</div>
                            <select className="value" type="text" name="croisiereCapitaineId" value={this.state.croisiereCapitaineId} onChange={e => this.change(e)} style={{width: "300px"}}>
                                <option value="null"></option>
                                {this.state.data.utilisateurs.map(utilisateur => (
                                    <option key={utilisateur.id} value={utilisateur.id}>{utilisateur.fullName}</option>
                                ))}
                            </select>

                            <div className="loginFormBox-line alignCenter">
                                <button type="submit" className="formSubmit">VALIDER</button>
                            </div>
                        </form>
                    </div>
                    <div id="croisiereDialog-content">
                        <div id="croisiereDialog-title">
                            <button className="link linkButton" type="button">Planing général</button>
                            <button className="link linkButton selected" type="button">Par jour</button>
                            <button className="link linkButton" type="button">Par bateau</button>
                        </div>
                        <div id="croisiereDialog-calendar">
                            <div id="calendarDialog">
                                <div id="calendar-box">
                                    {this.state.data.bateaux.map((bateau, index) => (
                                        <div key={bateau.id} className="calendar-column" style={this.getColumnStyle(bateau, index)}>
                                            <div className="calendar-column-title">{bateau.nom}</div>
                                            {this.state.data.croisieres.map(croisere => (
                                                <React.Fragment key={croisere.id}>
                                                    {croisere.bateau !== null && croisere.bateau.id === bateau.id &&
                                                        <div className="calendar-item" style={this.getItemStyle(croisere)}>#{croisere.id}</div>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    ))}
                                    <div className="calendar-column" style={{left: "756px"}}>
                                        <div className="calendar-column-title">Non défini</div>
                                        {this.state.data.croisieres.map(croisere => (
                                            <React.Fragment key={croisere.id}>
                                                {croisere.bateau == null &&
                                                    <div className="calendar-item" style={this.getItemStyle(croisere)}>#{croisere.id}</div>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>

                                <div className="calendar-time">10h00</div>
                                <div className="calendar-time" style={{top: "50px"}}>11h00</div>
                                <div className="calendar-time" style={{top: "100px"}}>12h00</div>
                                <div className="calendar-time" style={{top: "150px"}}>13h00</div>
                                <div className="calendar-time" style={{top: "200px"}}>14h00</div>
                                <div className="calendar-time" style={{top: "250px"}}>15h00</div>
                                <div className="calendar-time" style={{top: "300px"}}>16h00</div>
                                <div className="calendar-time" style={{top: "350px"}}>17h00</div>
                                <div className="calendar-time" style={{top: "400px"}}>18h00</div>
                                <div className="calendar-time" style={{top: "450px"}}>19h00</div>
                                <div className="calendar-time" style={{top: "500px"}}>20h00</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default CroisiereDialog;
